import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { LinkField } from '@prismicio/client';
import { LinkComponent } from 'link';

@Component({
  selector: 'lib-product-box-cta',
  imports: [CommonModule, LinkComponent],
  templateUrl: './product-box-cta.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductBoxCtaComponent {
  public ctaLink = input.required<LinkField>();
  public queryParams = input<object>();
  public ctaLabel = input.required<string>();
  public ctaClasses = input('');
  public ctaClick = output();
}
